import React from 'react';
import { useLocation } from 'react-router-dom';
import RovquestLogo from '../../assets/images/Rovquest_logo.svg';
import NavbarLink from './NavbarLink';
import Profile from './Profile';

import DashboardIcon from 'assets/icons/MenuBar/Dashboard_icon';
import AlcoholIcon from 'assets/icons/MenuBar/Alcohol_icon';
import AttendanceIcon from 'assets/icons/MenuBar/Attendance_icon';
import DriverIcon from 'assets/icons/MenuBar/Driver_icon';
import VehicleIcon from 'assets/icons/MenuBar/Vehicle_icon';
import DeviceIcon from 'assets/icons/MenuBar/Device_icon';
import ClientIcon from 'assets/icons/MenuBar/Client_icon';
import { useTranslation } from 'react-i18next';
import { Cog6ToothIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { getRoles } from 'config/session';

import {
  BASE_PATH,
  ALCOHOL_PATH,
  ATTANDANCE_PATH,
  DRIVER_PATH,
  VEHICLE_PATH,
  DEVICE_PATH,
  CLIENT_PATH,
  SETTINGS_COMPANY_PATH,
  OPERATOR_PATH,
} from 'router/pathName';

const Navbar: React.FC = () => {
  const { t } = useTranslation('layout');
  const location = useLocation();
  const currentPath = location.pathname;
  // YAC-2026-009 PR5a。管理者と運営を兼ねるアカウントには、運営の画面への項目を出す。
  const operatorToo = (getRoles() ?? []).includes('operator');

  return (
    // EV-324。高さが足りないときはサイドバー全体（内側の枠）を縦に送る。以前はメニューの枠の中だけを送り、最後の項目が
    // プロフィールの枠の上の端で切れて見えた（スクロールバーが出ない環境では送れることが分からない）。
    // メニューとプロフィールは縮めず、項目がプロフィールの枠に重ならない。足りるときは従来どおりプロフィールは下に付く。
    // 送る枠は外枠の内側に置く（外枠を送る枠にすると、横並びの中で外枠の最小の幅が 0 になり、サイドバーが細くなる）。
    <div className="w-[20%] bg-primary/300 h-screen">
      <div className="h-full flex flex-col overflow-y-auto" data-sidebar-scroll>
        {/* 2026-10-22 axe（link-name）。ロゴの画像は飾り（alt 空）なので、リンクに行き先の名前を付ける。 */}
        <a href="/" className="p-4 shrink-0" aria-label={t('home-link')}>
          <img src={RovquestLogo} alt="" />
        </a>
        <div className="shrink-0 p-4">
          <NavbarLink
            icon={<DashboardIcon color="#30537E" />}
            label={t('dashboard')}
            link={BASE_PATH}
            isSelected={currentPath === BASE_PATH}
          />
          <NavbarLink
            icon={<AlcoholIcon color="#30537E" />}
            label={t('alcohol')}
            link={ALCOHOL_PATH}
            isSelected={currentPath === ALCOHOL_PATH}
          />
          <NavbarLink
            icon={<AttendanceIcon color="#30537E" />}
            label={t('attendance')}
            link={ATTANDANCE_PATH}
            isSelected={currentPath === ATTANDANCE_PATH}
          />
          <NavbarLink
            icon={<DriverIcon color="#30537E" />}
            label={t('driver')}
            link={DRIVER_PATH}
            isSelected={currentPath.startsWith(DRIVER_PATH)}
          />
          <NavbarLink
            icon={<VehicleIcon color="#30537E" />}
            label={t('vehicle')}
            link={VEHICLE_PATH}
            isSelected={currentPath.startsWith(VEHICLE_PATH)}
          />
          <NavbarLink
            icon={<DeviceIcon color="#30537E" />}
            label={t('device')}
            link={DEVICE_PATH}
            isSelected={currentPath === DEVICE_PATH}
          />
          <NavbarLink
            icon={<ClientIcon color="#30537E" />}
            label={t('client')}
            link={CLIENT_PATH}
            isSelected={currentPath.startsWith(CLIENT_PATH)}
          />
          {/* EV-116 段階2B。会社の設定（時間帯）。 */}
          <NavbarLink
            icon={<Cog6ToothIcon color="#30537E" className="w-6 h-6" aria-hidden="true" />}
            label={t('company-settings')}
            link={SETTINGS_COMPANY_PATH}
            isSelected={currentPath === SETTINGS_COMPANY_PATH}
          />
          {operatorToo ? (
            <NavbarLink
              icon={<ShieldCheckIcon color="#30537E" className="w-6 h-6" aria-hidden="true" />}
              label={t('operator-menu')}
              link={OPERATOR_PATH}
              isSelected={false}
            />
          ) : null}
        </div>
        <div className="mt-auto shrink-0 p-4">
          <Profile />
        </div>
      </div>
    </div>
  );
};

export default Navbar;